<script>
    import CityParallelPlot from './CityParallelPlot.svelte';
    export let eCoords;
    export let tooltipFeatures;
    export let selectionData;
    export let accessScale;
    export let mainDrawColor;
    export let mainSpecialColor;
    export let mainBgColorControls;
    export let mainBorderColor;
    export let darkMode;
    export let innerWidth;
    export let innerHeight;
    export let visibility;
	export let borderWidthTooltip;
	export let boxShadow;
	export let mainSvgColor;

    // $: visibility = "visible";

    let tooltipWidth = 320;
    let tooltipHeight = 150;

    // $: console.log("eCoords", eCoords)
    // $: console.log("eFeatures", tooltipFeatures.properties)
    // $: console.log("selectionData", selectionData)

    $: aLevel = tooltipFeatures.properties.accessibility<=0.1?"very low":
              (tooltipFeatures.properties.accessibility>0.1)&&(tooltipFeatures.properties.accessibility<=0.4)?"low":
              (tooltipFeatures.properties.accessibility>0.4)&&(tooltipFeatures.properties.accessibility<=0.6)?"average":
              (tooltipFeatures.properties.accessibility>0.6)&&(tooltipFeatures.properties.accessibility<=0.8)?"high":
              tooltipFeatures.properties.accessibility>0.8?"very high":""
      
    $: color = accessScale(tooltipFeatures.properties.accessibility)


    function walkingTime(meters, short=false, lowerBound=false) {
		const km = meters/1000
		const hours = km/5
		const minutes = km/5 * 60
		const seconds = minutes*60
		// return hours or seconds or minutes
		if (short === true) {
			if (minutes<1) {
			// return seconds.toFixed() + "sec"
			return "less than 1 min."
			} else if (minutes>60){
			return hours.toFixed() + "h"
			} else {
			return minutes.toFixed() + "min"
			}
		} else {
			if (lowerBound===false) {
				if (minutes<1) {
				return "less than 1 minute"
				// return seconds.toFixed() + " seconds"
				} else if (minutes>60){
				return hours.toFixed() + " hours"
				} else {
				return minutes.toFixed() + " minutes"
				}
			} else {
				if (minutes<1) {
				return 1 + " minute"
				} else if (minutes>60){
				return hours.toFixed() + " hour"
				} else {
				return minutes.toFixed() + " minutes"
				}
			}
		}

		// return `${hours}, ${minutes}, ${seconds}`
    }

</script>

<div id="tooltip" style="z-index:10; 
                         max-width:320px; 
                         background: {mainBgColorControls}; 
                         fill: {mainBgColorControls}; 
                         border: {borderWidthTooltip}px solid {mainBorderColor};
						 box-shadow: {darkMode===true?"none":boxShadow};
                         position:absolute; 
						 border-radius:3px;
						 font-size: {innerWidth<400? "13px":"14.3px"};
                         visibility: {visibility};
                         left:{innerWidth<400?innerWidth*0.03:(innerWidth>400)&&(eCoords.x>innerWidth/2)?eCoords.x-330:eCoords.x+10}px; 
                         top:{eCoords.y>innerHeight/2?eCoords.y-215:eCoords.y+10}px">
    {#if innerWidth<640}
            <button class="closeButton" 
                    style="background-color: {mainBgColorControls};
                    color: {mainDrawColor};
                    transform:translate(300px, 5px);
                    border: 0px solid {mainBorderColor}" on:click={()=>{
                        visibility="hidden"
                        }}>X
            </button>
    {/if}
    <div style="margin:10px">
        <span style="color: {mainDrawColor}; text-align:left"> Accessibility to urban services for the <span style="color:{mainSpecialColor}"><b>{tooltipFeatures.properties.population.toFixed()}</b></span> residents of this area is</span> <b><span style="text-transform:uppercase;color:{mainSpecialColor}">{aLevel}</span></b><br>
    </div>
    <CityParallelPlot eFeatures={tooltipFeatures.properties} {mainSpecialColor} {mainSvgColor} {mainDrawColor} {mainBorderColor} {tooltipWidth} {tooltipHeight} {selectionData} {darkMode}/>
</div>

<style>

    .closeButton {
		position:absolute; 
		max-height:27px;
		font-weight:900;
		cursor:pointer;					
	}
    td {
	color: #ccc;
	border-bottom:1px solid black;
	border-bottom-width: 0px;
	z-index:0
	}

	.tableSep {
	border-left:1px solid #ccc;
	text-align: center;
	z-index:1
	}

	th {
	text-transform: uppercase;
	color: #ccc;
	border: none;
	}

	table, th, td {
	border-collapse: collapse;
	font-size:12px
	}

    #tooltip {
        font-size:11px;
    }

</style>